import { CTAPIConfiguration } from './utils/configuration';
import { RequestHelper } from './utils/request';
import { AddressRestInterface } from './interfaces/_address.rest';
import { Address } from '../models/interfaces/_address.model';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


export class AddressRest implements AddressRestInterface {

    private configuration: CTAPIConfiguration;
    private requestHelper: RequestHelper;

    constructor(configuration: CTAPIConfiguration) {
        this.configuration = configuration;
        this.requestHelper = new RequestHelper(configuration);
    }

    /**
     * Request for the saved address list.
     */
    getAddressList(nCustID: number, nDivID: number, sEnvCode, sLocaFullSearch, sLocaType?: string): Observable<Address[]> {
        return this.requestHelper.request(
            {
                data: { nCustID, nDivID, sEnvCode, sLocaFullSearch, sLocaType }
            },
            this.configuration.address.get,
            this.configuration.httpClient
        ).pipe(
            map((response) => {
                return response.result ? response.result.addresses : [];
            })
        );
    }

    /**
     * Request for the saved address list.
     */
    getCustomerAddressList(nCustID, nDivID, sEnvCode, sLocaFullSearch) {
        return this.requestHelper.request({
            data: { nCustID, nDivID, sEnvCode, sLocaFullSearch }
        }, this.configuration.address.getByCustomer, this.configuration.httpClient).pipe(map((response) => {
            return response.result ? response.result.addresses : [];
        }));
    }

    /**
     * Request for creation of new address.
     */
    saveAddress(nCustID: number, nDivID: number, address: Address, sEnvCode): Observable<any> {
        return this.requestHelper.request(
            {
                data: { nCustID, newAddress: address, nDivID, sEnvCode }
            },
            this.configuration.address.create,
            this.configuration.httpClient
        ).pipe(
            map((response) => {
                return response;
            })
        );
    }

    /**
     * Request for creation of new address.
     */
    validateAddress(address: Address, nDivID, sEnvCode): Observable<any> {
        return this.requestHelper.request(
            {
                data: { address, nDivID, sEnvCode }
            },
            this.configuration.address.validate,
            this.configuration.httpClient
        ).pipe(
            map((response) => {
                return (response) ? response.result : null;
            })
        );
    }

}
